import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-b2b-reports',
  templateUrl: './b2b-reports.component.html',
  styleUrls: ['./b2b-reports.component.css']
})
export class B2bReportsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
